import React, { memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useDndStore from '../stores/dndStore';
import { Box, Flex, Icon, useColorMode } from '@chakra-ui/react';
import { MotionBox, TrashIconRedHover } from './UiElements';
import { useDroppable } from '@dnd-kit/core';
import GroupDroppable from './GroupDroppableWrapper';
import usePersistStore from '../stores/persistStore';

const TrashDropZone = () => {
    let isDragging = useDndStore((state) => state.globalIsDragging);
    const showTrashZone = usePersistStore.getState().showTrashZone;
    const isOverContainer = useDndStore(
        (state) => state.overContainerZu === 'TrashDropZone'
    );
    // isDragging = true;

    const { setNodeRef } = useDroppable({
        id: 'TrashDropZone',
        data: { type: 'trashZone' }
    });

    const container = {
        show: {
            scale: 1,
            opacity: isOverContainer ? 1 : 0.45,
            //originY: 0.5,
            transition: {
                scale: { type: 'spring', damping: 20, stiffness: 180 }
            }
        },
        exit: {
            scale: 0,
            opacity: 0,
            //originY: 0,
            transition: { duration: 0 }
        }
    };

    if (!showTrashZone) return null;

    return (
        <GroupDroppable id={'TrashDropZone'}>
            <Box
                pos={'fixed'}
                left="0"
                right="0"
                bottom="8px"
                display="flex"
                textAlign="left"
                alignItems="center"
                justifyContent="center"
                zIndex="39"
                transform={isOverContainer ? 'scale(1.075)' : 'scale(1)'}
                transition={'0.2s'}
            >
                <AnimatePresence>
                    {isDragging && (
                        <MotionBox
                            ref={setNodeRef}
                            key={isDragging ? 'dragging' : 'notDragging'}
                            zIndex="3"
                            position="relative"
                            variants={container}
                            initial={{
                                scale: 0.9,
                                opacity: 0
                            }}
                            animate="show"
                            exit="exit"
                            whileHover="hover"
                            h="calc(72px + 1vh)"
                            w="calc(324px + 4vw)"
                            display="flex"
                            cursor="pointer"
                            textAlign="left"
                            borderRadius="16px"
                            border={'2px solid #F64545'}
                            bg={
                                isOverContainer
                                    ? 'rgb(255, 0, 0, 0.1)'
                                    : 'rgb(255, 0, 0, 0.1)'
                            }
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    margin: 'auto'
                                }}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                    fill="#F64545"
                                />
                            </svg>
                        </MotionBox>
                    )}
                </AnimatePresence>
            </Box>
        </GroupDroppable>
    );
};

export default TrashDropZone;
